import { initPerqButtonsHandler } from '../../../js/components/perq-controller';
import { isMobile } from '../../../js/modules/utilities';
import { GLOBAL_MODAL_ID, openModalGlobal, openModalGlobalConstructor } from '../../../js/components/modal';

export const video360TourLanding = () => {
  const video360tourEl = document.querySelector('div.video-360-tour');
  let items;
  let videos;
  let playerContainer;
  const MODAL_UNIQUE_ID = 'video-landing-modal';

  const rerenderVideoSection = (el) => {
    if (el && el.dataset) {
      const srcUrl = el.dataset.srcUrl;
      const previewUrl = el.dataset.previewUrl;
      const isVideo = el.classList.contains('video');
      const isTour = el.classList.contains('tour');
      playerContainer.style.borderRadius = null;

      if (srcUrl && playerContainer) {
        playerContainer.innerHTML = '';
        items.forEach(item => {
          if (item.classList.contains('active')) {
            item.classList.remove('active');
          }
        })
        el.classList.add('active');
        if (isVideo) {
          const video = document.createElement('video');
          video.setAttribute('poster', previewUrl);
          video.setAttribute('src', srcUrl);
          const customPlayBtn = document.createElement('div');
          customPlayBtn.innerText = 'play';
          customPlayBtn.classList.add('custom-play-btn');
          customPlayBtn.setAttribute('role', 'button');
          playerContainer.appendChild(video);
          playerContainer.appendChild(customPlayBtn);
          initCustomPlayButton();
        }

        if (isTour) {
          if (isMobile) {
            const div = document.createElement('div');
            div.dataset.srcUrl = srcUrl;
            div.classList.add('tour-360-thumbnail-mobile');
            const customPlayBtn = document.createElement('div');
            customPlayBtn.innerText = 'play';
            customPlayBtn.classList.add('custom-play-btn');
            customPlayBtn.setAttribute('role', 'button');
            const img = document.createElement('img');
            img.src = previewUrl;
            img.setAttribute('alt', '360-tour')
            div.appendChild(img);
            div.appendChild(customPlayBtn);
            playerContainer.appendChild(div);
            initCustomPlayButton();
          } else {
            const iframe = document.createElement('iframe');
            const src = isMobile ? `${srcUrl}?play=1` : srcUrl;
            iframe.setAttribute('src', src);
            iframe.setAttribute('allow', 'fullscreen');
            playerContainer.appendChild(iframe);
            if (src.includes('360ac')) {
              playerContainer.style.borderRadius = '20px';
            }
          }
        }
      }
    }
  }

  const onItemClickHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
    //rerenderVideoSection(e.currentTarget);
    items.forEach(item => {
      item.classList.toggle('active', item === e.currentTarget);
    })
    const target = e.currentTarget.dataset.targetId;
    const targetEl = document.querySelector(`[data-video-id="${target}"]`);
    videos.forEach(video => {
      video.classList.toggle('active', video === targetEl);
    })
  }

  const initListeners = () => {
    if (items.length) {
      items.forEach(item => {
        item.addEventListener('click', onItemClickHandler);
      })
    }
  }

  const videoPausePlayHandler = (e, videoPlayer, customPlayBtn) => {
    // const videoPlayer = playerContainer.querySelector('video');
    // const customPlayBtn = playerContainer.querySelector('.custom-play-btn');
    if (videoPlayer && customPlayBtn) {
      if (e.type === 'playing') {
        customPlayBtn.classList.add('hide');
        videoPlayer.setAttribute('controls', '');
      } else if (e.type === 'pause') {
        // customPlayBtn.classList.remove('hide');
        // videoPlayer.removeAttribute('controls', '');
      }
    }
  }

  const initMobileModal = (srcUrl) => {
    const src = `${srcUrl}&play=1`;
    const container = document.createElement('div');
    container.classList.add('tour-iframe-container');
    const iframe = document.createElement('iframe');
    iframe.setAttribute("allow", "fullscreen");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("src", `${src}`);
    container.appendChild(iframe);
    const actionsContainer = document.createElement('div');
    actionsContainer.classList.add('actions-container');
    const actions = document.createElement('div');
    actions.classList.add('actions');
    const applyNowBtn = video360tourEl.querySelector('.property-options-buttons .apply-cta');
    const tourYourWayBtn = video360tourEl.querySelector('.property-options-buttons .tour-your-way');
    const askQuestionBtn = video360tourEl.querySelector('.property-options-buttons .ask-question-btn');
    const viewCommunityBtn = video360tourEl.querySelector('.vlp-view-community-button');
    const callUsBtn = video360tourEl.querySelector('.property-options-buttons .vlp-call-us');
    const actionToggle = document.createElement('button');
    actionToggle.innerHTML = 'Learn More';
    actionToggle.classList.add('actions-toggle');
    actionToggle.addEventListener('click', () => {
      if (actionToggle.classList.contains('show-actions')) {
        actionToggle.classList.remove('show-actions');
        actionToggle.innerText = 'Actions';
      } else {
        actionToggle.classList.add('show-actions');
        actionToggle.innerText = 'Close';
      }
    })
    if (applyNowBtn) {
      actions.appendChild(applyNowBtn);
    }
    if (tourYourWayBtn) {
      actions.appendChild(tourYourWayBtn);
    }
    if (askQuestionBtn) {
      actions.appendChild(askQuestionBtn);
    }
    if (viewCommunityBtn) {
      actions.appendChild(viewCommunityBtn);
    }
    if (callUsBtn) {
      actions.appendChild(callUsBtn);
    }
    actionsContainer.appendChild(actions);
    actionsContainer.appendChild(actionToggle);
    container.appendChild(actionsContainer);

    openModalGlobalConstructor({ content: container, uniqueId: MODAL_UNIQUE_ID });
    // container.addEventListener('click', () => {
    //   console.log('!!11');
    // });
  }

  const customPlayBtnClickHandler = (e) => {
    // const videoPlayer = playerContainer.querySelector('video');
    // const tour = playerContainer.querySelector('.tour-360-thumbnail-mobile');
    const btn = e.currentTarget;
    const isVideo = btn.classList.contains('video') ? true : false;
    console.log('isVideo', isVideo, 'btn', btn);

    if (isVideo) {
      const videoPlayer = btn.previousElementSibling;
      videoPlayer.addEventListener('playing', function(e) { videoPausePlayHandler(e, videoPlayer, btn) }, false);
      videoPlayer.addEventListener('pause', function(e) { videoPausePlayHandler(e, videoPlayer, btn) }, false);
      if (videoPlayer.paused === true) {
        videoPlayer.play();
      }
    } else {
      const srcUrl = btn.parentElement.dataset.srcUrl;
      console.log('srcUrl', srcUrl, 'dataset', btn.dataset);
      if (srcUrl) {
        initMobileModal(srcUrl);
      }
    }
  }

  const initCustomPlayButton = () => {
    const customPlayBtn = playerContainer.querySelectorAll('.custom-play-btn');
    if (customPlayBtn) {
      customPlayBtn.forEach(btn => {
        btn.addEventListener('click', customPlayBtnClickHandler);
      })
    }
  }

  function determineStickyState() {
    const video = video360tourEl.querySelector('.list-item-header-video');
    const tour = video360tourEl.querySelector('.list-item-header-tour');
    if (video && tour) {
      const top = tour.offsetTop - video.offsetTop;
      video.classList.toggle('stuck', top === 44);
    }
  }

  const initActiveListItem = () => {
    if (video360tourEl) {
      const activeItem = video360tourEl.querySelector('.list-items .list-item.active');
      //rerenderVideoSection(activeItem);
    }
  }

  const init = () => {
    if (video360tourEl) {
      items = [...video360tourEl.querySelectorAll('.list-item')];
      playerContainer = video360tourEl.querySelector('#video-360-player-container');
      videos = [...playerContainer.querySelectorAll('.video-360-player__item')];
      initPerqButtonsHandler(video360tourEl);
      initListeners();
      initCustomPlayButton();
      //initActiveListItem();

      if (!isMobile) {
        document.querySelector('.list-items').addEventListener('scroll', determineStickyState);
      } else {
        document.addEventListener('beforeCloseModalEvent', ((e) => {
          if(e.detail.id && e.detail.id.includes(MODAL_UNIQUE_ID)){
            const modalGlobalEl = document.getElementById(GLOBAL_MODAL_ID);
            const applyNowBtn = modalGlobalEl.querySelector('.actions-container .apply-cta');
            const tourYourWayBtn = modalGlobalEl.querySelector('.actions-container .tour-your-way');
            const askQuestionBtn = modalGlobalEl.querySelector('.actions-container .ask-question-btn');
            const viewCommunityBtn = modalGlobalEl.querySelector('.actions-container .vlp-view-community-button');
            const callUsBtn = modalGlobalEl.querySelector('.actions-container .vlp-call-us');

            const propertyOptionsButtons = video360tourEl.querySelector('.property-options-buttons');
            const viewCommunityInfo = video360tourEl.querySelector('.video-360-tour-community-info');

            propertyOptionsButtons.appendChild(tourYourWayBtn);
            if (applyNowBtn) {
              propertyOptionsButtons.appendChild(applyNowBtn);
            }
            if (tourYourWayBtn) {
              propertyOptionsButtons.appendChild(tourYourWayBtn);
            }
            if (askQuestionBtn) {
              propertyOptionsButtons.appendChild(askQuestionBtn);
            }
            if (viewCommunityBtn) {
              viewCommunityInfo.appendChild(viewCommunityBtn);
            }
            if (callUsBtn) {
              propertyOptionsButtons.appendChild(callUsBtn);
            }
          }
        }));
      }
    }
  }

  init();
}



// WEBPACK FOOTER //
// ./src/templates/components/360-video-tour-landing/360-video-tour-landing.js